export default __webpack_public_path__ + "static/media/pro-elevate-bbl-banner-2.6219a5d1.jpg";